<template>
    <div class="brandList">
        <van-popup v-model="brandShow" @close='handleClose' position="right" :style="{ width: '60%', height: '100%' }" >
            <div class="content">
                <!-- <van-index-bar :index-list='indexList'>
                    <div v-for="(item, index) in brandList" :key="index + '00'">
                        <van-index-anchor :index='item.letter' />
                        <van-cell v-for="it in item.list" :key="it.id" :title="it.name" @click="handleTab(it)" />
                    </div>
                </van-index-bar> -->
                <mt-index-list :show-indicator="false">
                    <div v-for="(item, index) in brandList" :key="index + '00'">
                        <mt-index-section :index="item.letter">
                            <p v-for="it in item.list" :key="it.id" v-text="it.name" @click="handleTab(it)"></p>
                        </mt-index-section>
                    </div>
                </mt-index-list>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { getBrand } from '../../api/api'
export default {
    props: {
        brandReault: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        brandReault (val) {
            this.brandShow = val
        }
    },
    data () {
        return {
            brandShow: this.brandReault,
            indexList: [],
            brandList: []
        }
    },
    methods: {
        handleClose () {
            this.$emit('update:brandReault', false)
        },
        handleTab (data) {
            this.handleClose()
            this.$emit('brandClick', data)
        },
        async initPage () {
            const { data } = await getBrand({})
            this.brandList = data
            data.forEach(item => {
                this.indexList.push(item.letter)
            })
        }
    },
    mounted () {
        this.initPage()
    }
}
</script>
<style lang="scss" scoped>
    .content {
        padding: 32px 0;
        position: relative;
        height: 100%;
        overflow: auto;
    }
    /deep/ .van-popup {
        background: #f5f5f5;
    }
    // /deep/ .van-index-bar__index{
    //     line-height: initial;
    //     font-size: 22px;
    //     color: #666666;
    // }
    // /deep/ .van-index-anchor{
    //     font-size: 26px;
    //     color: #8E8E93;
    //     line-height: 36px;
    //     padding: 20px 24px 10px;
    // }
    // /deep/ .van-index-bar__sidebar{
    //     right: 12px;
    // }
    // /deep/ .van-cell {
    //     padding: 32px 24px;
    //     color: #000000;
    //     font-size: 32px;
    //     line-height: 44px;
    // }
    /deep/ .mint-indexlist-content {
        margin-right: 0 !important;
        z-index: 7;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        overflow-scrolling: touch;
    }
    /deep/ .mint-indexsection-index {
        font-size: 26px;
        color: #8e8e93;
        height: 36px;
        line-height: 36px;
        padding: 20px 32px 10px;
        background: none;
    }
    /deep/ .mint-indexsection-index + ul {
        background: #ffffff;
        overflow: hidden;
    }
    /deep/ .mint-indexsection-index + ul p {
        font-size: 28px;
        padding: 32px;
        color: #000000;
        position: relative;
    }
    /deep/ .mint-indexlist-navitem {
        font-size: 26px;
        color: #666666;
        padding-left: 14px;
        padding-right: 14px;
    }
    /deep/ .mint-indexlist-nav {
        position: fixed;
        background: none;
        border: none;
    }
    /deep/ .mint-indexlist-indicator {
        z-index: 9;
    }
</style>